import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { UserInfo } from '@shared/models/user-info';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UserService } from './services/user.service';

@Injectable()
export class OnboardedGuardService {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    avoidRedirect: boolean = false
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          if (!avoidRedirect) {
            if (localStorage.getItem('autoLogout') === 'true') {
              localStorage.removeItem('autoLogout');
              this.router.navigate(['/landing']);
            } else {
              this.router.navigateByUrl('/landing/true');
            }
          }
          return of(false);
        }

        return this.userService.getUserInfo().pipe(
          take(1),
          map(user => {
            if (!user) {
              if (!avoidRedirect) {
                this.router.navigate(['/onboarding']);
              }
              return false;
            }

            const hasActivePartner = !!user.partnerDetails?.isActive;
            const subscriptionsHistory = hasActivePartner ? [] : (user.subscriptionsHistory ?? []);
            const isSubscribed = hasActivePartner || subscriptionsHistory.length > 0;
            const onboarded =
              isSubscribed &&
              user.providerUserInfos &&
              user.providerUserInfos.filter(u => u.ledgerToken !== null && u.iban !== null).length === 1;
            const hasPropertiesSubscriptionActive = subscriptionsHistory
              .filter(x => x.isActive)
              .some(subscription => {
                return subscription.period === 3;
              });

            if (!onboarded && user != new UserInfo()) {
              if (!avoidRedirect) {
                this.router.navigate([hasPropertiesSubscriptionActive ? '/home' : '/onboarding']);
              }
              return false;
            }

            return true;
          })
        );
      })
    );
  }
}
